import * as _ from 'lodash';
import { GroupDivision } from '../../shared/enums/GroupDivision';

export class CompanyFinancial {
    _id: String;
    name: String;
    cnpj: String;
    group: GroupDivision

    constructor(data?) {
        this.populate(data);
    }

    populate(data) {
        _.forOwn(data, (value, key) => {
            this[key] = value;
        });
    }

    loadFromServer(r: any) {
        if (r._id != undefined)
            this._id = r._id;

        if (r.name != undefined)
            this.name = r.name;

        if (r.cnpj != undefined)
            this.cnpj = r.cnpj;
        
        if (r.group != undefined)
            this.group = r.group;

    }
}



// WEBPACK FOOTER //
// ./src/app/models/project/CompanyFinancial.model.ts